import IThresholdDataRepository from '../infractructure/repositories/iThresholdDataRepository';
import ThresholdDataRepository from '../infractructure/repositories/thresholdDataRepository';

class GetDLZDataService {
  private readonly _jitRepository: IThresholdDataRepository;

  constructor({ repository }) {
    this._jitRepository = repository;
  }

  execute() {
    return this._jitRepository
      .getDLZData()
      .then((res) => res)
      .catch((error: any) => {
        // Si es 404, devolver lista vacía
        if (error.message === 'Error: 404') {
          return {
            materialCoverageMaxThreshold: '0',
            dlzMaxTimeMinutes: 0,
            modifiedAt: '',
            modifiedBy: ''
          };
        }

        // Propagar otros errores
        throw error;
      });
  }
}

export default new GetDLZDataService({ repository: ThresholdDataRepository });

export { GetDLZDataService };
